export default "__VITE_ASSET__Gg1hfzq1__"